<div *ngIf="editableFields" class="custom-fields-container">
  <ng-container *ngFor="let _ of editableFields; let i = index; let even = even">
    <div *ngIf="even" class="custom-fields-row">
      <ic-custom-field-instance
        class="custom-field-cell"
        [defn]="editableFields[i].defn"
        [isDisabled]="isDisabled"
        [initValue]="editableFields[i].value"
        [externalState]="editableFields[i].externalState"
        (valueChange)="onValueChange($event)"
        [hasStrategyFill]="hasStrategyFill"
      >
      </ic-custom-field-instance>
      <ic-custom-field-instance
        *ngIf="i + 1 < editableFields.length"
        class="custom-field-cell"
        [defn]="editableFields[i+1].defn"
        [isDisabled]="isDisabled"
        [initValue]="editableFields[i+1].value"
        [externalState]="editableFields[i+1].externalState"
        (valueChange)="onValueChange($event)"
        [hasStrategyFill]="hasStrategyFill"
      >
      </ic-custom-field-instance>
    </div>
  </ng-container>
</div>
